<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8374_28035)">
      <path d="M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z"
            fill="url(#paint0_radial_8374_28035)"
      />
      <path d="M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z"
            fill="url(#paint1_radial_8374_28035)"
      />
      <path d="M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z"
            fill="url(#paint2_radial_8374_28035)"
      />
      <path d="M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z"
            fill="url(#paint3_radial_8374_28035)"
      />
      <path d="M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z"
            fill="url(#paint4_radial_8374_28035)"
      />
      <path d="M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z"
            fill="url(#paint5_radial_8374_28035)"
      />
      <path d="M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z"
            fill="url(#paint6_radial_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.0288 7.01562C16.5811 7.01562 17.0288 7.46334 17.0288 8.01562V16.011C17.0288 16.5633 16.5811 17.011 16.0288 17.011C15.4765 17.011 15.0288 16.5633 15.0288 16.011V8.01562C15.0288 7.46334 15.4765 7.01562 16.0288 7.01562Z"
            fill="url(#paint7_linear_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.0288 7.01562C16.5811 7.01562 17.0288 7.46334 17.0288 8.01562V16.011C17.0288 16.5633 16.5811 17.011 16.0288 17.011C15.4765 17.011 15.0288 16.5633 15.0288 16.011V8.01562C15.0288 7.46334 15.4765 7.01562 16.0288 7.01562Z"
            fill="url(#paint8_radial_8374_28035)"
            fill-opacity="0.15"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.0288 7.01562C16.5811 7.01562 17.0288 7.46334 17.0288 8.01562V16.011C17.0288 16.5633 16.5811 17.011 16.0288 17.011C15.4765 17.011 15.0288 16.5633 15.0288 16.011V8.01562C15.0288 7.46334 15.4765 7.01562 16.0288 7.01562Z"
            fill="url(#paint9_linear_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.0288 7.01562C16.5811 7.01562 17.0288 7.46334 17.0288 8.01562V16.011C17.0288 16.5633 16.5811 17.011 16.0288 17.011C15.4765 17.011 15.0288 16.5633 15.0288 16.011V8.01562C15.0288 7.46334 15.4765 7.01562 16.0288 7.01562Z"
            fill="url(#paint10_radial_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.0649 19.4837C21.7888 19.962 21.1772 20.1259 20.6989 19.8497L15.5312 16.8661C15.0529 16.59 14.889 15.9784 15.1652 15.5001C15.4413 15.0218 16.0529 14.858 16.5312 15.1341L21.6989 18.1177C22.1772 18.3938 22.3411 19.0054 22.0649 19.4837Z"
            fill="url(#paint11_linear_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.0649 19.4837C21.7888 19.962 21.1772 20.1259 20.6989 19.8497L15.5312 16.8661C15.0529 16.59 14.889 15.9784 15.1652 15.5001C15.4413 15.0218 16.0529 14.858 16.5312 15.1341L21.6989 18.1177C22.1772 18.3938 22.3411 19.0054 22.0649 19.4837Z"
            fill="url(#paint12_linear_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.0649 19.4837C21.7888 19.962 21.1772 20.1259 20.6989 19.8497L15.5312 16.8661C15.0529 16.59 14.889 15.9784 15.1652 15.5001C15.4413 15.0218 16.0529 14.858 16.5312 15.1341L21.6989 18.1177C22.1772 18.3938 22.3411 19.0054 22.0649 19.4837Z"
            fill="url(#paint13_radial_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.0649 19.4837C21.7888 19.962 21.1772 20.1259 20.6989 19.8497L15.5312 16.8661C15.0529 16.59 14.889 15.9784 15.1652 15.5001C15.4413 15.0218 16.0529 14.858 16.5312 15.1341L21.6989 18.1177C22.1772 18.3938 22.3411 19.0054 22.0649 19.4837Z"
            fill="url(#paint14_linear_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.0649 19.4837C21.7888 19.962 21.1772 20.1259 20.6989 19.8497L15.5312 16.8661C15.0529 16.59 14.889 15.9784 15.1652 15.5001C15.4413 15.0218 16.0529 14.858 16.5312 15.1341L21.6989 18.1177C22.1772 18.3938 22.3411 19.0054 22.0649 19.4837Z"
            fill="url(#paint15_radial_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
            fill="url(#paint16_linear_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
            fill="url(#paint17_radial_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
            fill="url(#paint18_radial_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
            fill="url(#paint19_radial_8374_28035)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
            fill="url(#paint20_radial_8374_28035)"
      />
      <path d="M18.0201 16.0113C18.0201 17.1097 17.1297 18.0001 16.0313 18.0001C14.9329 18.0001 14.0425 17.1097 14.0425 16.0113C14.0425 14.9129 14.9329 14.0225 16.0313 14.0225C17.1297 14.0225 18.0201 14.9129 18.0201 16.0113Z"
            fill="url(#paint21_radial_8374_28035)"
      />
      <path d="M18.0201 16.0113C18.0201 17.1097 17.1297 18.0001 16.0313 18.0001C14.9329 18.0001 14.0425 17.1097 14.0425 16.0113C14.0425 14.9129 14.9329 14.0225 16.0313 14.0225C17.1297 14.0225 18.0201 14.9129 18.0201 16.0113Z"
            fill="url(#paint22_radial_8374_28035)"
      />
    </g>
    <defs>
      <radialGradient id="paint0_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(9.57405 24.4982) rotate(-46.2124) scale(25.2966)"
      >
        <stop offset="0.598155"
              stop-color="#DDDADF"
        />
        <stop offset="1"
              stop-color="#BDBABF"
        />
      </radialGradient>
      <radialGradient id="paint1_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(14.6608 17.0297) rotate(67.6996) scale(3.59021 5.47985)"
      >
        <stop offset="0.219179"
              stop-color="#C3C0C7"
        />
        <stop offset="0.412477"
              stop-color="#C3C0C7"
              stop-opacity="0.730662"
        />
        <stop offset="0.595062"
              stop-color="#C3C0C7"
              stop-opacity="0.387105"
        />
        <stop offset="0.801937"
              stop-color="#C3C0C7"
              stop-opacity="0.123055"
        />
        <stop offset="1"
              stop-color="#C3C0C7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.0017 13.694) rotate(177.101) scale(1.74318 4.44536)"
      >
        <stop stop-color="#C3C0C7" />
        <stop offset="0.275013"
              stop-color="#C3C0C7"
              stop-opacity="0.769759"
        />
        <stop offset="0.492502"
              stop-color="#C3C0C7"
              stop-opacity="0.554237"
        />
        <stop offset="0.702058"
              stop-color="#C3C0C7"
              stop-opacity="0.25"
        />
        <stop offset="0.836314"
              stop-color="#C3C0C7"
              stop-opacity="0.0942649"
        />
        <stop offset="1"
              stop-color="#C3C0C7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint3_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.2344 10.2123) rotate(177.957) scale(1.97523 4.48433)"
      >
        <stop stop-color="#C3C0C7" />
        <stop offset="0.481368"
              stop-color="#C3C0C7"
              stop-opacity="0.554237"
        />
        <stop offset="0.70407"
              stop-color="#C3C0C7"
              stop-opacity="0.25"
        />
        <stop offset="0.836314"
              stop-color="#C3C0C7"
              stop-opacity="0.0942649"
        />
        <stop offset="1"
              stop-color="#C3C0C7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint4_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.1644 8.8358) rotate(-180) scale(1.82373 2.52067)"
      >
        <stop stop-color="#C3C0C7" />
        <stop offset="0.348958"
              stop-color="#C3C0C7"
              stop-opacity="0.554237"
        />
        <stop offset="0.70407"
              stop-color="#C3C0C7"
              stop-opacity="0.25"
        />
        <stop offset="0.836314"
              stop-color="#C3C0C7"
              stop-opacity="0.0942649"
        />
        <stop offset="1"
              stop-color="#C3C0C7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint5_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.522 18.4807) rotate(-56.3099) scale(1.90157 5.3634)"
      >
        <stop stop-color="#C3C0C7" />
        <stop offset="0.481368"
              stop-color="#C3C0C7"
              stop-opacity="0.554237"
        />
        <stop offset="0.70407"
              stop-color="#C3C0C7"
              stop-opacity="0.25"
        />
        <stop offset="0.836314"
              stop-color="#C3C0C7"
              stop-opacity="0.0942649"
        />
        <stop offset="1"
              stop-color="#C3C0C7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint6_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.9176 19.25) rotate(113.782) scale(2.02985 2.86421)"
      >
        <stop stop-color="#C3C0C7" />
        <stop offset="0.481368"
              stop-color="#C3C0C7"
              stop-opacity="0.554237"
        />
        <stop offset="0.70407"
              stop-color="#C3C0C7"
              stop-opacity="0.25"
        />
        <stop offset="0.836314"
              stop-color="#C3C0C7"
              stop-opacity="0.0942649"
        />
        <stop offset="1"
              stop-color="#C3C0C7"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint7_linear_8374_28035"
                      x1="16.0288"
                      y1="7.01562"
                      x2="16.0288"
                      y2="17.011"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F83F4C" />
        <stop offset="1"
              stop-color="#F74093"
        />
      </linearGradient>
      <radialGradient id="paint8_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.5032 10.1827) rotate(180) scale(0.765571 4.70148)"
      >
        <stop stop-color="#FFFFFF" />
        <stop offset="0.249149"
              stop-color="#FFFFFF"
              stop-opacity="0.9"
        />
        <stop offset="0.744082"
              stop-color="#FFFFFF"
              stop-opacity="0.275699"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint9_linear_8374_28035"
                      x1="15.0213"
                      y1="10.6072"
                      x2="16.1892"
                      y2="10.6072"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.131311"
              stop-color="#A23A67"
        />
        <stop offset="0.706607"
              stop-color="#A23A67"
              stop-opacity="0.165681"
        />
        <stop offset="1"
              stop-color="#A23A67"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint10_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.5539 11.2727) rotate(-116.461) scale(4.65972 4.49433)"
      >
        <stop stop-color="#A23A67"
              stop-opacity="0"
        />
        <stop offset="0.802314"
              stop-color="#A23A67"
              stop-opacity="0"
        />
        <stop offset="0.83572"
              stop-color="#A23A67"
              stop-opacity="0.0962606"
        />
        <stop offset="0.894579"
              stop-color="#A23A67"
              stop-opacity="0.285673"
        />
        <stop offset="1"
              stop-color="#A23A67"
        />
      </radialGradient>
      <linearGradient id="paint11_linear_8374_28035"
                      x1="22.0649"
                      y1="19.4837"
                      x2="17.0321"
                      y2="16.578"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#32183D" />
        <stop offset="1"
              stop-color="#2C3A65"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_8374_28035"
                      x1="19.9407"
                      y1="17.1026"
                      x2="19.4407"
                      y2="17.9686"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2E2840" />
        <stop offset="1"
              stop-color="#2E2840"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint13_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.836 19.0178) rotate(-148.255) scale(5.8369 0.830453)"
      >
        <stop stop-color="#50375F" />
        <stop offset="1"
              stop-color="#50375F"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint14_linear_8374_28035"
                      x1="22.0649"
                      y1="19.4837"
                      x2="21.4434"
                      y2="19.1249"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3E1846" />
        <stop offset="1"
              stop-color="#3E1846"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint15_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.4451 19.32) rotate(-144.829) scale(0.725104 1.11664)"
      >
        <stop stop-color="#50375F" />
        <stop offset="0.463278"
              stop-color="#50375F"
              stop-opacity="0.515368"
        />
        <stop offset="0.795574"
              stop-color="#50375F"
              stop-opacity="0.132882"
        />
        <stop offset="1"
              stop-color="#50375F"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint16_linear_8374_28035"
                      x1="24.5108"
                      y1="4.01349"
                      x2="4.28379"
                      y2="28.5336"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6D6B70" />
        <stop offset="1"
              stop-color="#706C74"
        />
      </linearGradient>
      <radialGradient id="paint17_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.4007 15.8125) rotate(149.639) scale(14.563)"
      >
        <stop offset="0.914731"
              stop-color="#484150"
              stop-opacity="0"
        />
        <stop offset="0.928424"
              stop-color="#484150"
              stop-opacity="0.101097"
        />
        <stop offset="0.939283"
              stop-color="#484150"
              stop-opacity="0.27"
        />
        <stop offset="0.969496"
              stop-color="#484150"
              stop-opacity="0.77"
        />
        <stop offset="0.988059"
              stop-color="#484150"
        />
      </radialGradient>
      <radialGradient id="paint18_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.5514 16.3031) rotate(-37.0827) scale(14.5121)"
      >
        <stop stop-color="#888888"
              stop-opacity="0"
        />
        <stop offset="0.938413"
              stop-color="#888888"
              stop-opacity="0"
        />
        <stop offset="0.952942"
              stop-color="#888888"
              stop-opacity="0.128798"
        />
        <stop offset="0.972799"
              stop-color="#888888"
              stop-opacity="0.53"
        />
        <stop offset="0.988906"
              stop-color="#888888"
              stop-opacity="0.822895"
        />
        <stop offset="1"
              stop-color="#888888"
        />
      </radialGradient>
      <radialGradient id="paint19_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.7251 16.3399) rotate(149.509) scale(11.4835)"
      >
        <stop stop-color="#888888" />
        <stop offset="0.935213"
              stop-color="#888888"
        />
        <stop offset="0.9577"
              stop-color="#888888"
              stop-opacity="0.679592"
        />
        <stop offset="0.984798"
              stop-color="#888888"
              stop-opacity="0.155947"
        />
        <stop offset="1"
              stop-color="#888888"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint20_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.3574 15.7218) rotate(-42.8395) scale(11.4828 11.6469)"
      >
        <stop offset="0.925335"
              stop-color="#484150"
        />
        <stop offset="0.940224"
              stop-color="#484150"
              stop-opacity="0.881499"
        />
        <stop offset="0.964456"
              stop-color="#484150"
              stop-opacity="0.588909"
        />
        <stop offset="0.989814"
              stop-color="#484150"
              stop-opacity="0.11"
        />
        <stop offset="1"
              stop-color="#484150"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint21_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.0327 15.5144) rotate(132.631) scale(3.37856)"
      >
        <stop stop-color="#C9C6CC" />
        <stop offset="0.101161"
              stop-color="#C9C6CC"
        />
        <stop offset="0.259126"
              stop-color="#C3C0C6"
        />
        <stop offset="0.371041"
              stop-color="#BAB7BD"
        />
        <stop offset="0.793546"
              stop-color="#928E95"
        />
      </radialGradient>
      <radialGradient id="paint22_radial_8374_28035"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.3946 15.7036) rotate(139.867) scale(2.60049)"
      >
        <stop offset="0.487329"
              stop-color="#776F7F"
              stop-opacity="0"
        />
        <stop offset="0.532414"
              stop-color="#776F7F"
              stop-opacity="0.0470898"
        />
        <stop offset="0.576462"
              stop-color="#776F7F"
              stop-opacity="0.12"
        />
        <stop offset="0.76616"
              stop-color="#776F7F"
              stop-opacity="0.498077"
        />
        <stop offset="1"
              stop-color="#776F7F"
        />
      </radialGradient>
      <clipPath id="clip0_8374_28035">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
